// Pure helper: given an income label/name, guess the most likely
// incomeType. Used by the entry forms (pre-selecting the dropdown)
// and by the one-time backfill migration. '1099' matches on common
// freelance/contract vocabulary; everything else defaults to 'w2'.
// 'other' is never auto-assigned — only user-selectable.
const PATTERN_1099 = /(?:freelance(?:r)?|1099|contract(?:or)?|gig|consult(?:ing|ant)?|self.?employ)/i;

export function classifyIncomeLabel(label) {
  if (!label || typeof label !== 'string') return 'w2';
  return PATTERN_1099.test(label) ? '1099' : 'w2';
}
